$('.js-refer-a-group__form').on('submit', function(e) {
  e.preventDefault();
  $.ajax({
    method: "POST",
    url: "https://hooks.zapier.com/hooks/catch/2383820/wxgtjs/",
    data: $('.js-refer-a-group__form').serializeArray()
  }).done(function(msg) {
    $('.js-refer-a-group__form').html("<h3 class='refer-a-group__success'>Thanks!</h3><p class='refer-a-group__success'>We'll follow up with the group admin shortly and will be in touch with your gift card once they've set up their account!</p>")
    window.snowplow('trackStructEvent', 'form', 'submit', 'amazon_gift_card', '', 0.0);
  });
});
